var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropPref(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9641_4839)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.16667L6.74479 8.93939L6.7462 8.94067C6.17497 9.66677 5.83333 10.5882 5.83333 11.5909C5.83333 13.9339 7.69881 15.8333 10 15.8333C12.3012 15.8333 14.1667 13.9339 14.1667 11.5909C14.1667 10.5882 13.825 9.66677 13.2538 8.94067L13.2552 8.93939L10 4.16667ZM11.0416 14.7727C12.1922 14.7727 13.125 13.823 13.125 12.6515C13.125 11.48 12.1922 10.5303 11.0416 10.5303C9.89105 10.5303 8.95831 11.48 8.95831 12.6515C8.95831 13.823 9.89105 14.7727 11.0416 14.7727Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C15.5229 20 20 15.5228 20 10C20 4.47715 15.5229 0 10 0C4.47713 0 0 4.47715 0 10C0 15.5228 4.47713 20 10 20ZM10 18.3333C14.6024 18.3333 18.3333 14.6024 18.3333 10C18.3333 5.39762 14.6024 1.66667 10 1.66667C5.39764 1.66667 1.66667 5.39762 1.66667 10C1.66667 14.6024 5.39764 18.3333 10 18.3333Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9641_4839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropPref);
export default __webpack_public_path__ + "static/media/DropPref.b29954ea2cd4181ae630d4610c43cd66.svg";
export { ForwardRef as ReactComponent };